// store.js
import { createStore, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import rootReducer from ".";

const xTablesStore = createStore(
  rootReducer,
  applyMiddleware(thunk),
);

export default xTablesStore;